module.exports = __webpack_public_path__ + "static/media/FinX Privacy Policy New.695d7a2b.pdf";